import { PublicKey } from "@solana/web3.js";

export const programId = new PublicKey(
  "GovER5Lthms3bLBqWub97yVrMmEogzX7xNjdXpPPCVZw"
);
